import * as React from 'react';
import { Button } from 'react-admin';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
    to?: string;  // 添加to属性用于指定返回路径
}

const BackButton = ({ to }: BackButtonProps) => {
    const navigate = useNavigate();

    return (
        <Button
            label="返回"
            onClick={() => navigate(to || -1)}  // 使用传入的路径，否则返回历史记录
            sx={{ marginRight: '10px' }}
        >
            <ArrowBackIcon />
        </Button>
    );
};

export default BackButton;